
//import { changeVisualizerBackgroundColorDiagram, getVisualizerBackgroundColorDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import {getVisualizerBackgroundColorDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
export type VisualizerBackgroundProps = {
    VisualizerBackground?: string;
}

//export const changeVisualizerBackgroundColor = ({ VisualizerBackground }: VisualizerBackgroundProps) =>
//    changeVisualizerBackgroundColorDiagram({ VisualizerBackground });

export const getVisualizerBackgroundColor = () => getVisualizerBackgroundColorDiagram();
